import * as actionTypes from "Application/Store/Actions/AnimationTypes"

/*****************************************************************
 *  Animation Reducer
 * ***************************************************************/

const initialState = {
    times: [],
    metas: {},
    keyframe: 0,
    autoRotate: false,
    loaded: false,
    animationVisibility: 'flex',
    increment: 0,
    nbMaxi: 0,
    nbMandi: 0
}

/**
 * Update State
 * @param {object} state
 * @param {*} action
 * @returns
 */
export const AnimationReducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.INIT_ANIMATION:
          return {
            ...state,
            times: action.payload,
          }
        case actionTypes.ACTUAL_KEYFRAME:
          return {
            ...state,
            keyframe: action.payload
          }
        case actionTypes.CAMERA_AUTO:
          return {
            ...state,
            autoRotate: action.payload
          }
        case actionTypes.INIT_METAS:
          return {
            ...state,
            metas: action.payload,
          }
        case actionTypes.SCENE_LOADED:
          return {
            ...state,
            loaded: true
          }
        case actionTypes.SET_KEYFRAME_TO_END:
          return {
            ...state,
            keyframe: action.payload
          }
        case actionTypes.SET_KEYFRAME_TO_BEGIN:
            return {
                ...state,
                keyframe: action.payload
            }
        case actionTypes.SET_KEYFRAME_TO:
            return {
                ...state,
                keyframe: action.payload
            }
        case actionTypes.TOOGLE_ANIMATION_VISIBLE:
          return {
            ...state,
            animationVisibility: action.payload
          }
        case 'SET_INCREMENT':
          return {
            ...state,
            increment: action.payload
          };
        case 'SET_NBMAXI':
          return {
            ...state,
            nbMaxi: action.payload
          };
        case 'SET_NBMANDI':
          return {
            ...state,
            nbMandi: action.payload
          };


        default:
          return state
      }
}
